// --------------------------
// IMPORTS
// --------------------------
import { Link } from "react-router-dom";
import AddForm from "../../molecules/Forms/addForm";
import FileUpload from "../../../utils/FileUpload";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { decryptData } from "../../../utils/Constants";
import media from "../../../media";
import AddExpense from "../../../views/AddNewExpense";
import { Modal } from "antd";
import SubmitButton from "./SubmitButton";

// --------------------------
// MAIN COMPONENT
// --------------------------
const AddNewButton = (props) => {
  //Dispatch + Custom Hooks

  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeRole = useSelector((state) => state.auth.role);
  const storeUserInfo = useSelector((state) => state.auth.userInfo);
  const decryptedUserInfo = useMemo(
    () => decryptData(storeUserInfo),
    [storeUserInfo]
  );
  const storeCanSendExpenseRequest =
    decryptedUserInfo?.user?.canSendExpenseRequest;

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [isModalVisible, setIsModalVisible] = useState(false);

  // --------------------------
  // PROPS
  // --------------------------
  const {
    addNewButtonClassName,
    addNewButtonName,
    href,
    btnType,
    onClick,
    deleteOnClick,
    isVisible,
    setIsVisible,
    setShowLoader,
    payload,
    list,
    headers,
    formFields,
    successMessage,
    onSuccess,
    selectedRowKeys,
  } = props;

  // --------------------------
  // HANDLERS
  // --------------------------
  const handleClickForBlockingRaisingExpenseRequest = () => {
    const today = new Date();
    const day = today.getDate(); // 1–31

    if (day >= 10 && day <= 15) {
      setIsModalVisible(true);
      return;
    } else {
      setIsVisible(true);
    }
  };

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      {btnType === "dshButton" && storeCanSendExpenseRequest === true ? (
        <button
          type="button"
          className={addNewButtonClassName}
          onClick={() => {
            handleClickForBlockingRaisingExpenseRequest();
          }}
        >
          + {addNewButtonName}
        </button>
      ) : (
        <>
          {selectedRowKeys?.length > 0 && (
            <button
              className="btn mx-auto px-5 py-2 rounded-lg defalutWhiteBtn mr-10"
              onClick={deleteOnClick}
            >
              <img src={media.delete.svg} alt="Delete icon" />{" "}
              <span>Delete</span>
            </button>
          )}
          {addNewButtonName && (
            <button
              className={addNewButtonClassName}
              type="button"
              onClick={onClick}
            >
              + {addNewButtonName}
            </button>
          )}
        </>
      )}
      {/* {sectionTitle==="Currency" && storeRole === process.env.REACT_APP_SROLE ||
            storeRole === process.env.REACT_APP_ADROLE} */}
      {addNewButtonName === "Import bulk data" ? (
        <FileUpload
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          role={storeRole}
        />
      ) : (
        formFields && (
          <AddForm
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            setShowLoader={setShowLoader}
            name={addNewButtonName}
            payload={payload}
            list={list}
            headers={headers}
            formFields={formFields}
            successMessage={successMessage}
            onSuccess={onSuccess}
          />
        )
      )}
      {addNewButtonName === "Add your expenses" && isVisible && (
        <AddExpense isVisible={isVisible} setIsVisible={setIsVisible} />
      )}

      <Modal
        className="custom-modal"
        title="Expense Submission Restricted"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <SubmitButton
            key="okay"
            type="primary"
            htmlType="submit"
            submitName="Okay"
            className="btn px-5 py-2 defaultbutton rounded-lg"
            onClick={() => setIsModalVisible(false)}
          />,
        ]}
        destroyOnClose
      >
        <p className="text-dark-grey-custom">
          Raising expense requests is not allowed between the 10th and 15th of
          every month.
        </p>
      </Modal>
    </>
  );
};

export default AddNewButton;
